const getFirstMessage = (...values) => {
  return values.find((value) => typeof value === 'string' && value.trim()) || null
}

const getBarrierRequestErrorMessage = (requestError) => {
  const responseData = requestError?.response?.data

  if (typeof responseData === 'string') {
    return responseData
  }

  return getFirstMessage(responseData?.message, responseData?.error, responseData?.data?.message, responseData?.data?.error)
}

const BARRIER_TYPE_LABELS = {
  entry: 'Giriş yaptınız.',
  exit: 'Çıkış yaptınız.',
}

const BARRIER_METHOD_LABELS = {
  gps: 'GPS',
  bluetooth: 'Bluetooth',
  both: 'GPS ve Bluetooth',
}

const getBarrierSuccessMessage = (responseData) => {
  const data = responseData?.data || responseData?.item || responseData
  const barrierTypeText = BARRIER_TYPE_LABELS[data?.barrier_type] || 'Bariyer açılıyor, giriş yapabilirsiniz.'
  const methodText = BARRIER_METHOD_LABELS[data?.method]

  if (!methodText) {
    return barrierTypeText
  }

  return `${barrierTypeText}\nDoğrulama yöntemi: ${methodText}.`
}

export { getBarrierRequestErrorMessage, getBarrierSuccessMessage }
